import { ArrowLeft, ArrowRight } from '@drift-labs/icons';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import usePnlModalCardImagePaths from 'src/components/Modals/PnlModal/hooks/usePnlModalCardImagePaths';
import { cj } from 'src/utils/classNames';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { PnlModalVariant } from 'src/components/Modals/PnlModal/types';

interface Props {
	marketIndex?: number;
	backgroundImagePathIndex: number;
	setBackgroundImagePathIndex: (index: number) => void;
	className: string;
	/**
	 * The number of pixels applied to the `left` and `right` position of the controls.
	 */
	xOffset: number;
	variant: PnlModalVariant;
}

export default function PnlModalPaginationControls({
	marketIndex,
	backgroundImagePathIndex,
	setBackgroundImagePathIndex,
	className,
	xOffset,
	variant,
}: Props) {
	const backgroundImagePaths = usePnlModalCardImagePaths({
		marketIndex,
		variant,
	});
	const isMobileScreenSize = useIsMobileScreenSize();

	const goBack = (e: React.MouseEvent<HTMLButtonElement>) => {
		// Prevent the event from propagating to the underlying overlay.
		e.stopPropagation();

		setBackgroundImagePathIndex(
			(backgroundImagePathIndex - 1 + backgroundImagePaths.length) %
				backgroundImagePaths.length
		);
	};

	const goForward = (e: React.MouseEvent<HTMLButtonElement>) => {
		// Prevent the event from propagating to the underlying overlay.
		e.stopPropagation();

		setBackgroundImagePathIndex(
			(backgroundImagePathIndex + 1) % backgroundImagePaths.length
		);
	};

	if (backgroundImagePaths.length === 1) {
		return null;
	}

	return (
		<>
			<IconButton
				className={cj('absolute', className)}
				size={isMobileScreenSize ? 'md' : 'lg'}
				variant="primary"
				style={{ left: `${xOffset}px` }}
				onClick={goBack}
				icon={ArrowLeft}
			/>
			<IconButton
				className={cj('absolute', className)}
				size={isMobileScreenSize ? 'md' : 'lg'}
				variant="primary"
				style={{ right: `${xOffset}px` }}
				onClick={goForward}
				icon={ArrowRight}
			/>
		</>
	);
}
